import { useRoutes } from 'react-router-dom';
import RouteConfig from './routeConfig';

const Routes = () => {
  return useRoutes(RouteConfig());
};

export default Routes;
